module.exports = __webpack_public_path__ + "img/55.8f3134b6.jpg";